export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";